// extracted by mini-css-extract-plugin
export default {"bg":"Background_bg__+KPQn"};